<template>
  <DatatableReportV3
    title="Forms & Checklists Completion"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useStore } from "vuex";

import { Filter } from "@/components/DatatableV3.vue";
import {
  submissionColumns,
  submissionStatusChipComponent
} from "@/CustomForms/formsAndChecklistsColumns";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

withDefaults(
  defineProps<{
    source?: string;
    filters?: Filter[];
  }>(),
  {
    source: "",
    filters: () => []
  }
);

// The phone order belongs to this report, not to the shared column list: the
// customer record's Forms tab renders the same columns without collapsing.
// Kept longest first.
const PHONE_ORDER = [
  "customer",
  "form",
  "status",
  "attached_on",
  "submitted_at",
  "job_id",
  "appointment_id",
  "department",
  "required_for_close",
  "required_progress",
  "overall_progress",
  "submitted_by"
];

const config = {
  responsive: true,
  columns: submissionColumns().map((column) => ({
    ...column,
    responsivePriority: PHONE_ORDER.indexOf(column.data) + 1
  })),
  vueComponents: [submissionStatusChipComponent]
};

const store = useStore();

onMounted(() => {
  store.dispatch("addBreadcrumb", { label: "Forms & Checklists Completion" });
});
</script>
